import React from 'react'
import { connect } from "react-redux"

import VideoThumb from '../../video/VideoThumb'
import SessionComments from '../../ui/SessionComments';
import DoneImg from '../../ui/images/check_circle_white.svg'
import ShowCategories from '../../ui/ShowCategories'
import CategoryAreas from '../../ui/CategoryAreas'

import Avatar from '../../user/Avatar'
import moment from 'moment'
import { deleteImage } from '../../../actions/images'

import { setModal } from '../../../actions/index'
import { toggleVideoDoneAndSave } from '../../../actions/patient'

@connect((store) => {
    return { therapy_areas: store.therapy_areas, therapy_categories: store.therapy_categories, sessions: store.sessions, videos: store.videos, modal: store.modal }
})
class SessionComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            "active_category": null
        }
        this.toggleVideoDone = this.toggleVideoDone.bind(this)
        this.setActiveVideo = this.setActiveVideo.bind(this)
        this.categoryAreas = this.categoryAreas.bind(this)
        this.categoryClick = this.categoryClick.bind(this)
        this.deleteImage = this.deleteImage.bind(this)
        this.deleteInternalImage = this.deleteInternalImage.bind(this)
        this.formatText = this.formatText.bind(this)
    }

    categoryClick(id) {
        let _id = this.state.active_category === id
            ? null
            : id
        this.setState({ "active_category": _id })
    }

    formatText(t = '', keyName = '--') {
        return t.split('\n').map((t, i) => (
            <p key={
                `${keyName}_p_${i}`
            }> {t}</p>)
        );
    }

    setActiveVideo(id) {
        let data = {
            ...this.props.modal.data,
            activeVideoId: id
        }
        this.props.dispatch(setModal('ParentSession', null, {
            ...this.props.modal.data,
            ...data
        }, true, 'fullscreen'))
    }

    deleteImage(img) {
        if (confirm('Really delete this image?')) {
            deleteImage(img);
            this.props.removeImage(img);
        }
    }

    deleteInternalImage(img) {
        if (confirm('Really delete this image?')) {
            deleteImage(img);
            this.props.removeInternalImage(img);
        }
    }

    toggleVideoDone(sessionId, videoId) {
        let { dispatch } = this.props;
        dispatch(toggleVideoDoneAndSave(sessionId, videoId))
    }

    categoryAreas() {
        let { therapy_areas, sessionId, sessions } = this.props;
        let session = sessions[sessionId];

        if(!therapy_areas) return []

        return session.therapy_areas.filter(areaId => {
            if(!therapy_areas[areaId]) return []
            therapy_areas[areaId].categories.indexOf(this.state.active_category) !== -1
        }).map(areaId => therapy_areas[areaId])
    }

    render() {
        let {
            sessionId,
            sessions,
            close,
            videos,
            activeVideoId,
            therapy_categories,
            therapy_areas
        } = this.props;
        let { active_category } = this.state;
        let session = sessions[sessionId];
        session.comments = session.comments || {};
        console.log('here')

        return <div className={"modal-fill sessionView" + (
            !activeVideoId && 'scroll')}>
            <div className="modal-header">
                <Avatar pic={session.therapist.picture} />
                <div className="modal-title fill">
                    <b>
                        {
                            session.dateSent
                                ? <span>{moment(session.dateSent).format('ddd Do of MMM YYYY h:mm a')}
                                    - {moment(session.dateSent).fromNow()}</span>
                                : <span>{moment(session.created).format('ddd Do of MMM YYYY h:mm a')}
                                    - {moment(session.created).fromNow()}</span>
                        }
                    </b>
                </div>
                <div className="close link" onClick={close}>X</div>
            </div>
            <div className="modal-content">
                <div>
                    <p>
                        <b>Session Date</b>
                        {moment(session.created).format('ddd Do of MMM YYYY')}
                    </p>
                </div>
                <div>
                    <p>
                        <b>Internal notes</b>
                    </p>
                    <div className="sessionNotes">
                        {this.formatText(session.internal_notes, 'internal-notes')}
                    </div>
                    <br />

                    <div className="grid gallery ">
                        {
                            session.internal_images && (session.internal_images.map(img => (<div className="image-container" key={img.thumb}>
                                <img className="shadow" role="presentation" src={img.thumb} />
                                <a className="link" onClick={() => {
                                    this.deleteInternalImage(img)
                                }}>Delete</a>
                            </div>)))
                        }
                    </div>
                </div>
                <hr />
                <div className="section videoSection paddingless">
                    <div className="md-subhead">
                        <center>Homework</center>
                    </div>
                    <div className="video-grid grid horizontal-row">
                        {
                            session.videos.map(videoId => <div className="thumb" key={videoId}>
                                <div className="card dark marginless" style={{
                                    opacity: session.videos_done[videoId]
                                        ? '1'
                                        : '0.6'
                                }} onClick={() => {
                                    this.setActiveVideo(videoId)
                                }}><VideoThumb class="min-video" video={videos[videoId]} /> {
                                        session.videos_done[videoId] && <img alt="Mark as done" src={DoneImg} style={{
                                            height: '18px',
                                            position: 'absolute',
                                            right: '4px',
                                            bottom: '4px'
                                        }} />
                                    }
                                </div>
                            </div>)
                        }
                    </div>
                </div>

                <div>
                    <p>
                        <b>Areas worked on:
                        </b>
                    </p>
                    <ShowCategories active_category={active_category} click={this.categoryClick} therapy_areas={session.therapy_areas.map(areaId => therapy_areas[areaId])} therapy_categories={therapy_categories} />
                    <CategoryAreas active_category={active_category} therapy_areas={this.categoryAreas()} />

                </div>
                <hr />
                <div>
                    <p>
                        <b>Parent notes</b>
                    </p>
                    {this.formatText(session.parent_notes, 'parent-notes')}
                </div>
                <div className="grid gallery ">
                    {
                        session.images && (session.images.map(img => <div className="image-container" key={img.thumb}>
                            <img role="presentation" className="shadow" src={img.thumb} />
                            <a className="link" onClick={() => {
                                this.deleteImage(img)
                            }}>Delete</a>
                        </div>))
                    }
                </div>
                <div >
                    <hr />
                    <p>
                        <center>Comments</center>
                    </p>
                    <SessionComments session={session} />
                </div>
            </div>

        </div>
    
    }

}

SessionComponent.defaultProps = {
    sessions: {},
    therapy_areas: {},

    videos: {},
    activeVideoId: null,
    setActiveVideo: () => { }
}

export default SessionComponent;



// WEBPACK FOOTER //
// ./src/components/practice_admin/patient/SessionComponent.jsx